firebird.factory('configService', [
    'logService',
    'helperService',
    'storageService',
    function (logService, helperService, storageService) {
        var service = {
            readStorage: readStorage,
            getClientValue: getClientValue,
            getServerValue: getServerValue,
            getValue: getValue,
            setSfuPayload: setSfuPayload,
            getSfuPayload: getSfuPayload,
            getHasMultishare: getHasMultishare,
            getMultisharePrompt: getMultisharePrompt,
            isLayoutLockAvailable: isLayoutLockAvailable,
            isLayoutLockLocked: isLayoutLockLocked,
            getHasFeatureFlags: getHasFeatureFlags,
            setConfigObjectFromName: setConfigObjectFromName,
            setConfigObjectFromCSV: setConfigObjectFromCSV,
            setLogLevelFromConfig: setLogLevelFromConfig
        };

        var settings = null; // from local storage
        var sfuPayload = {}; // from user pairs

        const logger = logService.createLoggerWithSource('[configService]');

        service.hasFixScreenSimple = true;
        return service;

        ////////////////////////

        function readStorage(meetingCode) {
            // delete advancedSettings if not saved for all meetings, and this is a different meeting.
            var box = JSON.parse(storageService.get('advancedSettingsBox') || '{}');
            if (box.meeting && meetingCode && box.meeting != meetingCode) {
                logger.log(
                    'readStorage',
                    'delete advancedSettings as for different meeting ' + box.meeting + ' != ' + meetingCode
                );
                storageService.remove('advancedSettings');
            }

            settings = JSON.parse(storageService.get('advancedSettings') || '{}');
            return settings;
        }

        function getClientValue(attr) {
            return helperService.getQueryParameter(attr) || (settings || {})[attr] || null;
        }

        function getServerValue(attr) {
            return (sfuPayload || {})[attr] || null;
        }

        function getValue(attr) {
            return getClientValue(attr) || getServerValue(attr);
        }

        function setSfuPayload(newSfuPayload) {
            sfuPayload = newSfuPayload;
        }

        function getSfuPayload() {
            return sfuPayload || {};
        }

        function getHasMultishare() {
            return '' + service.getServerValue('multishare') == 'true';
        }

        function getMultisharePrompt() {
            return '' + service.getServerValue('multisharePrompt') === null
                ? 'true'
                : service.getServerValue('multisharePrompt'); // default is true
        }

        function isLayoutLockAvailable() {
            return service.getServerValue('layoutLock') != 'false';
        }

        function isLayoutLockLocked() {
            return service.getServerValue('layoutLock') == 'locked';
        }

        function getHasFeatureFlags() {
            return (service.getValue('featureFlags') || 'false') != 'false';
        }

        function setConfigObjectFromName(config, name, newOptions) {
            const options = { convert: true, default: false };
            if (newOptions && typeof newOptions === 'object') {
                Object.assign(options, newOptions);
            }
            if (!config) {
                config = {};
            }
            let configValue = service.getValue(name);
            if (configValue) {
                if (configValue === 'true') {
                    config.enabled = true;
                } else if (configValue === 'false') {
                    config.enabled = false;
                } else {
                    service.setConfigObjectFromCSV(config, configValue, options);
                    config.enabled = true;
                }
            } else {
                config.enabled = options.default;
            }
        }

        // parse value as "name:value,name:value,..." and update config object.
        // if create is true, then also create new attributes if missing in the config object.
        function setConfigObjectFromCSV(config, value, options) {
            if (typeof value !== 'string' || value === 'true' || value === 'false') {
                return;
            }
            const attributes = getAttributesFromCSV(value);
            attributes.forEach(function (data) {
                let created = false,
                    existing = data.attr
                        ? data.obj && data.attr && config[data.obj] && config[data.obj][data.attr]
                        : data.obj && config[data.obj];

                if (options && options.create && existing === undefined) {
                    // create and initialize to null
                    created = true;
                    if (data.attr) {
                        if (config[data.obj] === undefined) {
                            config[data.obj] = {};
                        }
                        existing = config[data.obj][data.attr] = null;
                    } else {
                        existing = config[data.obj] = null;
                    }
                }

                if (existing !== undefined) {
                    var val = data.val;
                    if (created && existing === null) {
                        if (val === 'null') {
                            val = null;
                        } else if (val === 'true' || val === 'false') {
                            val = val == 'true';
                        } else if (isFloat(val)) {
                            val = parseFloat(val);
                        } // remains as string
                    } else if (typeof existing === 'boolean') {
                        if (options && options.convert) {
                            // only allow null, boolean or number.
                            if (val === 'null') {
                                val = null;
                            } else if (isFloat(val)) {
                                val = parseFloat(val);
                            } else {
                                // any other non-'true' string becomes false.
                                val = val == 'true';
                            }
                        } else {
                            val = val == 'true';
                        }
                    } else if (typeof existing === 'number') {
                        if (options && options.convert) {
                            // only allow null, number, or boolean.
                            if (val === 'null') {
                                val = null;
                            } else if (val === 'true' || val === 'false') {
                                val = val == 'true';
                            } else {
                                // number or NaN. never string
                                val = parseFloat(val);
                            }
                        } else {
                            val = parseFloat(val);
                        }
                    } else if (typeof existing === 'string' || existing === null) {
                        val = val == 'null' ? null : val;
                    }

                    if (data.attr) {
                        config[data.obj][data.attr] = val;
                    } else {
                        config[data.obj] = val;
                    }
                }
            });
        }

        // Return mapped objects from CSV
        function getAttributesFromCSV(str) {
            return str.split(',').map(function (nv) {
                let index = nv.indexOf(':');
                const name = index >= 0 ? nv.substring(0, index) : nv;
                const val = index >= 0 ? nv.substring(index + 1) : null;
                index = name.indexOf('.');
                const obj = index >= 0 ? name.substring(0, index) : name;
                const attr = index >= 0 ? name.substring(index + 1) : null;
                return { obj: obj, attr: attr, val: val };
            });
        }

        function isFloat(value) {
            return ('' + value).match(/^-?\d+\.?\d*$/);
        }

        function setLogLevelFromConfig() {
            const config = service.getValue('customLogLevel');
            const logLevel =
                config === 'true' ? 0 : !config || config === 'false' || isNaN(config) ? null : parseInt(config);
            if (logLevel !== null) {
                logger.info('setLogLevelFromConfig', `Setting custom log level=${logLevel}`);
            }
            logService.setCustomLogLevel(logLevel);
        }
    }
]);
